import { initialOrders } from '../data/orders';

/** IDs from bundled mock data (`data/orders.ts`) — often copied into Firestore for demos. */
const BUNDLED_SAMPLE_ORDER_IDS = new Set(initialOrders.map((o) => o.id));

/**
 * Orders that should not appear in the live POS "Pending" queue (seed / demo / training data).
 * Covers: `data/orders.ts` fixtures, `scripts/setup-demo.js` (ORD-LIVE-*, ORD-HIST-*).
 */
export function isSampleOrDemoOrderId(id: string | undefined | null): boolean {
  if (!id) return false;
  if (BUNDLED_SAMPLE_ORDER_IDS.has(id)) return true;
  if (id.startsWith('ORD-LIVE-') || id.startsWith('ORD-HIST-')) return true;
  return false;
}
